module.exports = __webpack_public_path__ + "static/media/logo-dd.f0f7cac9.svg";